const timeDiff = { timeDiff: 0 };
export default timeDiff;
